// extracted by mini-css-extract-plugin
export default {"searchWrapper":"UserManagement_searchWrapper__iy7b6"};